import { msalInstance } from './authConfig'
import { useStoreUser } from '../stores/userStore';

function isInteractionInProgress() {
  return window.sessionStorage.getItem('msal.interaction.status') === 'inProgress';
}

let getTokenInProgress = false;

export async function getToken() {
  if (getTokenInProgress) {
// console.log('[auth.ts] getToken() already in progress, skipping.');
    return null;
  }
  getTokenInProgress = true;
  try {
    await msalInstance.initialize();
    if (isInteractionInProgress()) {
// console.log('[auth.ts] MSAL interaction is already in progress.');
      return null;
    }

    const accounts = msalInstance.getAllAccounts();
    const apiScope = import.meta.env.VITE_API_SCOPE;
    const scopes = apiScope ? [apiScope] : [];
    const userStore = useStoreUser();

    if (!accounts || accounts.length === 0) {
      if (!isInteractionInProgress()) {
        await msalInstance.loginPopup({ scopes });
      }
      return null;
    }

    try {
      const response = await msalInstance.acquireTokenSilent({
        account: accounts[0],
        scopes,
      });
      msalInstance.setActiveAccount(accounts[0]);

      userStore.accessToken = response.accessToken;
      userStore.isAuthenticated = true;

      // console.log("                   auth SERVICE :   Setting Access Token SAVED to  Local Storage");
      // Save access token to localStorage
      localStorage.setItem("accessToken", response.accessToken);

      userStore.fetchUserData();


      return userStore.accessToken;
    } catch (e) {
      await msalInstance.acquireTokenRedirect({ scopes });
      msalInstance.setActiveAccount(accounts[0]);
      return null;
    }
  } finally {
    getTokenInProgress = false;
  }
}

export async function login() {

  const apiScope = import.meta.env.VITE_API_SCOPE;

  const scopes = apiScope ? [apiScope] : [];

  await msalInstance.initialize();

  if (!isInteractionInProgress()) {

    await msalInstance.loginPopup({ scopes });

      await getToken();
      // Use the path for Home, not the route name
      msalInstance.loginRedirect();

      // await msalInstance.loginRedirect({
      //   // scopes,
      //   // redirectUri: "/home" // or your desired path
      // });
  }

}

export async function logout() {
  await msalInstance.initialize();
  msalInstance.logoutRedirect();
}

